<script setup lang="ts">
// COMPOSABLES
const { tt } = useTypedI18n();

// DATA
const openModel = defineModel<boolean>('open', { required: true });
</script>

<template>
    <button
        type="button"
        class="flex cursor-pointer items-center p-3"
        :aria-label="tt('common.mainMenu')"
        :aria-expanded="openModel"
        @click="openModel = !openModel"
    >
        <UIcon :name="openModel ? 'lucide:x' : 'lucide:menu'" class="text-3xl" />
    </button>
</template>
